import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./languages/en/translation.json";
import translationDK from "./languages/da/translation.json";
import { normalizeLang } from "./utils/translation";

const resources = {
  en: {
    translation: translationEN,
  },
  da: {
    translation: translationDK,
  },
};

const savedLanguage = localStorage.getItem("i18nextLng");
// Captured before init, which writes the resolved language back, so a page
// can still tell a first-time visitor from one who chose English.
export const hasSavedLanguage = savedLanguage !== null;
const storedLanguage = normalizeLang(savedLanguage);
localStorage.setItem("i18nextLng", storedLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    debug: false,
    lng: storedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
